import { http } from '../http';
import { transformBlockingRule } from 'BlockList/utils/transformBlockingRule';
import type {
  BlockingRule,
  BlockingRuleWire,
} from 'BlockList/types/blockingRule';

// ---------------------------------------------------------------------------
// Response shape (snake_case wire) — wrapped in { data: BlockingRuleWire }
// ---------------------------------------------------------------------------

type ServerResponse = {
  data: BlockingRuleWire;
};

// ---------------------------------------------------------------------------
// Service function
// ---------------------------------------------------------------------------

/**
 * PATCH /clearcover_admin/blocklist/rules/{id}
 *
 * Toggles the `enabled` state of a blocking rule. Body MUST be exactly
 * `{ enabled }` (no other fields) per OpenAPI UpdateBlockingRuleRequest.
 *
 * Returns the updated BlockingRule (camelCase) on 200.
 * Throws on 4xx/5xx so callers can extract the error via `extractReznorError`.
 */
export const patchBlockingRule = (
  token: string,
  id: string,
  enabled: boolean
) => {
  return http.patch<BlockingRule>(
    {
      url: `/clearcover_admin/blocklist/rules/${id}`,
      token,
      transformResponse: (jsonData: string | ServerResponse): BlockingRule => {
        const raw: ServerResponse =
          typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
        return transformBlockingRule(raw.data);
      },
    },
    { enabled }
  );
};
